// eslint-disable-next-line import/no-cycle
import { adminApi } from '@/includes/contentManagementApi';

export default class NetworkWorkshop {
  static getListWorkshop(config) {
    return adminApi.get('workshop', config);
  }

  static createWorkshop(data, config) {
    return adminApi.post('workshop', data, config);
  }

  static updateWorkshop(id, data, config) {
    return adminApi.put(`workshop/${id}`, data, config);
  }

  static deleteWorkshop(id, config) {
    return adminApi.delete(`workshop/${id}`, config);
  }

  static sendReflexionWorkshop(data, config) {
    return adminApi.post('workshop/send-reflexion', data, config);
  }

  static getQuestionAnswers(data, config) {
    return adminApi.post('workshop/get-question-answers', data, config);
  }

  static getWorkshopTags(config) {
    return adminApi.get('workshop/getWorkshopTags', config);
  }
}
